import { useNavigate, useParams } from "react-router-dom";
import { Box } from "@mui/material";
import JumboCardQuick from "@jumbo/components/JumboCardQuick";
import ContentHeader from "components/ContentHeader/ContentHeader";
import useAdmin from "app/routes/middleware/Admin/useAdmin";
import { useCallback } from "react";
import entityService from "app/services/entity-service";
import GenericEntityForm from "components/common/GenericEntityForm";
import useMetaTitle from "app/hooks/useMetaTitle";

const AdminEntityDetails = ({ entityConfig }) => {
  const { id } = useParams();
  const isAdmin = useAdmin();
  const navigate = useNavigate();

  const handleBack = useCallback(() => {
    if (entityConfig.uiPaths.list?.path) {
      navigate(entityConfig.uiPaths.list.path);
    }
  }, [navigate, entityConfig.uiPaths.list]);

  const handleAdd = useCallback(() => {
    if (entityConfig.uiPaths.add?.path) {
      navigate(entityConfig.uiPaths.add.path);
    }
  }, [entityConfig.uiPaths.add, navigate]);

  const handleUpdate = useCallback(() => {
    if (entityConfig.uiPaths.update?.path) {
      navigate(entityConfig.uiPaths.update.path.replace(":id", id));
    }
  }, [entityConfig.uiPaths.update, navigate, id]);

  const handleAction = useCallback(
    (action) => {
      switch (action.id) {
        case "back":
          handleBack();
          break;
        case "add":
          handleAdd();
          break;
        case "update":
          handleUpdate();
          break;
        default:
          console.log("Unknown action:", action);
      }
    },
    [handleBack, handleAdd, handleUpdate]
  );

  useMetaTitle({
    title: id && id,
  });

  return (
    <Box sx={{ height: "100%" }}>
      <JumboCardQuick
        title={
          <ContentHeader
            entityConfig={entityConfig}
            isAdmin={isAdmin}
            onAction={handleAction}
            allowedActions={isAdmin ? ["add", "update", "back"] : ["back"]}
            showLeftTabs={true}
            actionLabels={{
              add: `Add New ${entityConfig.sectionTitle}`,
              update: `Update ${entityConfig.sectionTitle}`,
            }}
          />
        }
        headerSx={{
          borderBottom: 1,
          borderColor: "divider",
          "& .MuiCardHeader-action": { my: -0.75 },
        }}
        wrapperSx={{ p: 0 }}
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          "& .MuiCardContent-root:last-child": { paddingBottom: 0 },
          "& .MuiCardContent-root": {
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <GenericEntityForm
          entityConfig={entityConfig}
          id={id}
          mode="view"
          fetchService={entityService.fetchDetailsById}
          createService={entityService.create}
          updateService={entityService.update}
          title={`View ${entityConfig.sectionTitle}`}
        />
      </JumboCardQuick>
    </Box>
  );
};

export default AdminEntityDetails;
